<template>
	<Row>
		<SIcon class="mr-3" v-if="item.prependIcon" :name="item.prependIcon" :width="item.prependIconWidth" />
		{{ item.text }}
		<SIcon class="ml-1" v-if="item.appendIcon" :name="item.appendIcon" :width="item.appendIconWidth" />
		<component :is="indicator" v-if="isUpgradeRequired" :billingFeatureId="item.billingFeatureId" iconOnly class="ml-2" />
	</Row>
</template>

<script>
export default {
	name: 'AppDropdownMenuItem',
	components: {},
	props: {
		item: { type: Object },
		isUpgradeRequired: { type: Boolean, default: false },
		indicator: { type: Object, default: null },
	},
};
</script>

<style scoped lang="scss">
.app-dropdown-menu {
	&::before {
		content: none !important;
	}
}
.menu-item {
	font-size: 14px;
	font-weight: normal;
	color: var(--primary-font-color);
}

.menu_btn {
	border-radius: 1px;

	&::before {
		content: none !important;
	}
}

.v-menu__content {
	.v-divider {
		margin: 3px 0;
	}
}
</style>
